import { render } from "./WhyThisMattersSection.vue?vue&type=template&id=450d60be"
import script from "./WhyThisMattersSection.vue?vue&type=script&lang=js"
export * from "./WhyThisMattersSection.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__